import axios from 'axios';
import { BACKEND_URL } from '../config/features';
import { mirrorSessionRemoval } from '../mobile/session';

const API_BASE_URL = BACKEND_URL;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
});

apiClient.interceptors.request.use(
  (config) => {
    const isFormDataPayload = typeof FormData !== 'undefined' && config.data instanceof FormData;
    if (isFormDataPayload && config.headers) {
      if (typeof config.headers.delete === 'function') {
        config.headers.delete('Content-Type');
        config.headers.delete('content-type');
      } else {
        delete config.headers['Content-Type'];
        delete config.headers['content-type'];
      }
    }

    const token = localStorage.getItem('correfood_token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const accessCode = localStorage.getItem('correfood_access_code');

    if (accessCode) {
      config.headers['X-Access-Code'] = accessCode;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) {
      console.log('Request canceled:', error.message);
      return Promise.reject({ name: 'AbortError', message: 'Request canceled' });
    }

    if (error.response?.status === 401) {
      localStorage.removeItem('correfood_token');
      localStorage.removeItem('correfood_user');
      void mirrorSessionRemoval(['correfood_token', 'correfood_user']);
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export const createCancelTokenSource = () => {
  return axios.CancelToken.source();
};

export const isAbortError = (error) => {
  return error.name === 'AbortError' || axios.isCancel(error);
};

export default apiClient;

